const _require = require(/* webpackIgnore: true */'../lib/evaluateSource'),
  evaluateSource = _require.evaluateSource;
/**
 * @function evaluate - evaluate expenseTotalsBehavior
 */
// expenseTotalsBehavior goes through each expense collection
// added by the user, and checks for a value in the ‘amount’ field.
// If it does not find that value it calculates the product
// of rate and distance and assigns that value to ‘amount’.
// It will then check for a selected payment method or ‘type’
// and assign that to the ‘itemExpenseIdentifier’.
// The tally of 'amount' for each separate ‘itemExpenseIdentifier’
// will populate where ‘itemExpenseIdentifier’ === ‘expenseIdentifier’.
// Where the ‘expenseIdentifier’ does not exist, it will append the grand total
// of all expenses entered.
const evaluate = async (source, content, parentContentPath, transientContext, nativeFunctions) => {
  const expenseCollection = await evaluateSource(source.expenseCollection, content, parentContentPath, transientContext, nativeFunctions);
  if (expenseCollection === undefined) {
    return 0;
  }
  const expenseIdentifier = await evaluateSource(source.expenseIdentifier, content, parentContentPath, transientContext, nativeFunctions);
  let total = 0;
  const keys = Object.keys(expenseCollection);
  keys.forEach(key => {
    const _expenseCollection$ke = expenseCollection[key],
      type = _expenseCollection$ke.type,
      rate = _expenseCollection$ke.rate,
      distance = _expenseCollection$ke.distance;
    let amount = expenseCollection[key].amount;

    // Assign calculation if amount is undefined
    amount = amount !== null && amount !== void 0 ? amount : rate * distance;

    // Check if amount is a valid number
    if (Number.isNaN(amount)) {
      return;
    }
    /*
     * Check if 'expenseIdentifier' is undefined,
     * or if 'type' is defined and has a key matching 'expenseIdentifier'.
     */
    if (expenseIdentifier === undefined || type && Object.keys(type).includes(expenseIdentifier)) {
      total += amount;
    }
  });
  return total;
};
module.exports = {
  evaluate
};